// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__1i8l0","Wrapper":"Header_Wrapper__6MG0t","Heading":"Header_Heading__1FKZ8","subHeading":"Header_subHeading__123YX"};